export const logo_jj = require('./logo_jj.png');
export const saude = require('./saude.png');
export const PersonDesktopIMG = require('./person-with-desktop.png');
export const LogoIMG = require('./logo.png');
